



















































































































































































































































































































































import { Component, Prop } from "vue-property-decorator";
import { ICodeList, IThaiArea, IMapFilter } from "@/components/map/types";
import Map from "@/components/map/Map";
import SearchBase from "./search.base";

@Component
export default class SearchMap extends SearchBase {
  @Prop({
    default: null
  }) data: {
    $map: Map;
    filter: IMapFilter
  };
  
  created() {
    this.initialize(this.data);
  }
}
